<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Result Form Data Loading...
  </div>

  <div v-else class="animated fadeIn">
    <b-form @submit.prevent="submitForm">
      <b-card no-body>
        <b-card-header>
          <span class="text-muted text-uppercase">Result</span>
        </b-card-header>

        <div class="py-3 px-4">
          <b-form-group label="Raw Result" :label-cols="2">
            <b-form-input
              type="text"
              v-model="form_data.raw_result"
              placeholder="Raw Result"
              :state="!$v.form_data.raw_result.$invalid"
            />
          </b-form-group>

          <b-form-group label="Formatted Result" :label-cols="2">
            <b-form-input
              v-model="form_data.formatted_result"
              placeholder="Formatted Result"
              :state="!$v.form_data.formatted_result.$invalid"
            />
          </b-form-group>
        </div>
      </b-card>

      <!-- validation error -->
      <b-row v-if="invalid" class="mt-4">
        <b-col>
          <b-alert variant="danger" show>
            <i class="fa fa-exclamation-triangle" /> Please review the form and complete all required fields.
          </b-alert>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-button
            type="submit"
            class="my-4 float-right py-3 px-5"
            variant="success"
          >
            <i class="fal fa-save" /> Save
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'ResultManagerForm',
  mixins: [validationMixin],
  props: {
    analyte_result: {
      type: Object,
      default: () => null
    }
  },
  data () {
    return {
      loading: false,
      form_data: {
        raw_result: null,
        formatted_result: null,
      }
    }
  },
  validations: {
    form_data: {
      raw_result: { required },
      formatted_result: { required }
    }
  },
  computed: {
    invalid () {
      return this.$v && this.$v.$dirty && this.$v.$invalid
    }
  },
  created () {
    this.loading = true

    this.init()

    this.loading = false
  },
  methods: {
    submitForm () {
      this.$v.$touch()
      if (this.invalid) return

      this.$emit('submit', this.form_data)
    },
    async init () {
      if (this.analyte_result && this.analyte_result.id) {
        _.keys(this.form_data).forEach((key) => {
          if (this.analyte_result[key] !== undefined) {
            this.form_data[key] = this.analyte_result[key]
          }
        })
      }
    }
  }
}
</script>
